import styled from "styled-components";

import { COLORS } from "../../../../theme";

export const FilterBarContainer = styled.div`
  background-color: ${COLORS.blackSqueeze};
  padding: 1.25rem 0.6875rem;
  margin-top: 1.5rem;
`;
